<app-hierarchy-filter (applied)="onFiltersApplied()" (cleared)="onFiltersCleared()"></app-hierarchy-filter>
<!-- FILTER BAR (Financial Year / Filter Type / Month / Quarter /  -->
<dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'" class="input-box-section"
    style="padding: 0.5rem 1rem; margin-bottom: 1rem">

    <dxi-item [ratio]="6" class="separate-input-field">
        <label class="lable" for="FinancialYearRef">
            {{ langService.currentLang === 'mr' ? 'आर्थिक वर्ष' : 'Financial Year' }}
        </label>
        <dx-select-box id="FinancialYearRef" [(ngModel)]="FinancialYearRef" [items]="YearsList"
            displayExpr="p.short_name" valueExpr="p.id" name="FinancialYearRef"
            placeholder="{{ 'REPORT_PLACEHOLDERS.Select' | translate }}"
            [inputAttr]="{ 'aria-label': 'FinancialYearRef' }" style="width: 100%" [searchEnabled]="true"
            class="inputfield" (onValueChanged)="onYearChanged($event)">
        </dx-select-box>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field">
        <label class="lable" for="FilterRef">
            {{ langService.currentLang === 'mr' ? 'फिल्टर प्रकार' : 'Filter Type' }}
        </label>
        <dx-select-box id="FilterRef" [(ngModel)]="ReportFilterType" [items]="FilterList"
            [displayExpr]="getTranslatedName" valueExpr="Ref" name="Role"
            placeholder="{{ 'REPORT_PLACEHOLDERS.Select' | translate }}" [inputAttr]="{ 'aria-label': 'FilterRef' }"
            style="width: 100%" [searchEnabled]="true" class="inputfield"
            (onValueChanged)="OnFilterChange(ReportFilterType)">
        </dx-select-box>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field"
        [visible]="!IsShowMonth && !IsShowDates && !IsShowQuarter && !IsShowHalfYear">
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field" [visible]="IsShowHalfYear">
        <label for="HalfYear" class="lable">{{ 'FILTER_LABELS.HalfYear' | translate }}</label>
        <dx-select-box id="HalfYear" [(ngModel)]="HalfYearType" [items]="HalfYearList" [displayExpr]="getTranslatedName"
            valueExpr="Ref" name="HalfYear" [placeholder]="'REPORT_PLACEHOLDERS.SelectHalfYear' | translate"
            [inputAttr]="{ 'aria-label': 'HalfYear' }" style="width: 100%" [searchEnabled]="true" class="inputfield"
            (onValueChanged)="onHalfYearChanged($event)">
        </dx-select-box>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field" [visible]="IsShowQuarter">
        <label for="Quarter" class="lable">{{ 'FILTER_LABELS.Quarter' | translate }}</label>
        <dx-select-box id="Quarter" [(ngModel)]="QuarterlyYearType" [items]="QuarterList"
            [displayExpr]="getTranslatedName" valueExpr="Ref" name="Quarter"
            placeholder="{{ 'REPORT_PLACEHOLDERS.SelectQuarter' | translate }}"
            [inputAttr]="{ 'aria-label': 'Quarter' }" style="width: 100%" [searchEnabled]="true" class="inputfield"
            (onValueChanged)="onQuarterChanged($event)">
        </dx-select-box>
    </dxi-item>

    <dxi-item [ratio]="6" class="separate-input-field" [visible]="IsShowMonth">
        <label for="Month" class="lable">{{ 'FILTER_LABELS.Month' | translate }}</label>
        <dx-select-box id="Month" [(ngModel)]="Month" [items]="MonthList" [displayExpr]="getTranslatedName"
            valueExpr="Ref" name="Month" [placeholder]="'REPORT_PLACEHOLDERS.SelectMonth' | translate"
            [inputAttr]="{ 'aria-label': 'Month' }" style="width: 100%" [searchEnabled]="true" class="inputfield"
            (onValueChanged)="onMonthChanged($event)">
        </dx-select-box>
    </dxi-item>

    <!-- Actions: Refresh Button & Filter popup toggle -->
    <dxi-item [ratio]="2">
        <div class="dashboard-actions-container">
            <!-- REFRESH BUTTON WRAPPER WITH USER GUIDE CALLOUT -->
            <div class="refresh-btn-wrapper">
                <button type="button" class="dashboard-refresh-btn" [class.highlight-pulse]="isDataStale"
                    [class.refreshing]="isRefreshing" [class.just-updated]="justUpdated" [disabled]="isRefreshing"
                    (click)="refreshDashboard()" [title]="isDataStale 
                        ? (langService.currentLang === 'mr' ? 'नवीन माहिती उपलब्ध आहे - रिफ्रेश करा' : 'New data available - Click to refresh')
                        : (langService.currentLang === 'mr' ? 'माहिती अद्यतनित करा' : 'Refresh Dashboard')">

                    <span class="refresh-icon-wrap" [class.spinning]="isRefreshing">
                        <svg class="refresh-svg" viewBox="0 0 24 24" width="18" height="18" fill="none"
                            stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.19" />
                        </svg>
                    </span>

                    <span class="refresh-label">
                        {{ isRefreshing
                        ? (langService.currentLang === 'mr' ? 'अद्यतनित...' : 'Refreshing...')
                        : (langService.currentLang === 'mr' ? 'रिफ्रेश' : 'Refresh') }}
                    </span>

                    <!-- Stale Attention Pulse Badge / Dot -->
                    <span *ngIf="isDataStale" class="refresh-badge-dot">
                        <span class="badge-ping"></span>
                        <span class="badge-core"></span>
                    </span>
                </button>

                <!-- USER GUIDE POINTER (Points directly to the refresh button) -->
                <div *ngIf="isDataStale && !isRefreshing && !isGuideDismissed" class="refresh-user-guide"
                    (click)="refreshDashboard()"
                    [title]="langService.currentLang === 'mr' ? 'रिफ्रेश करण्यासाठी येथे क्लिक करा' : 'Click to refresh data'">
                    <div class="guide-pointer-arrow">
                        <div class="guide-pointer-badge">
                            <svg class="guide-up-arrow" viewBox="0 0 24 24" width="16" height="16" fill="none"
                                stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="12" y1="19" x2="12" y2="5"></line>
                                <polyline points="5 12 12 5 19 12"></polyline>
                            </svg>
                        </div>
                    </div>
                    <div class="guide-card">
                        <div class="guide-header">
                            <span class="guide-pulse-beacon"></span>
                            <span class="guide-title">
                                {{ langService.currentLang === 'mr' ? 'नवीन माहिती उपलब्ध!' : 'Updates Available!' }}
                            </span>
                            <button type="button" class="guide-close-btn" (click)="dismissGuide($event)"
                                [title]="langService.currentLang === 'mr' ? 'मार्गदर्शक बंद करा' : 'Close Guide'">
                                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                        <div class="guide-desc">
                            {{ langService.currentLang === 'mr' ? 'नवीनतम आकडेवारीसाठी येथे क्लिक करा' : 'Click here to
                            refresh latest data' }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- FILTER BUTTON -->
            <button *ngIf="DashboardFilterService.HasAnyVisibleFilter" class="menu-button filter-toggle-btn"
                (click)="openFilterPanel()" [title]="langService.currentLang === 'mr' ? 'फिल्टर' : 'Filter'"
                style="background: none; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center;">
                <img src="assets/icons/filter_pink.png" alt="Toggle Menu" style="width: 34px; height: 34px" />
            </button>
        </div>
    </dxi-item>
</dx-box>

<!-- STALE DATA ALERT BANNER (Shows when user stays on dashboard) -->
<!-- <div *ngIf="isDataStale && !isBannerDismissed && !isUrbanNoData" class="stale-data-banner">
    <div class="banner-content">
        <div class="banner-icon-wrap">
            <svg class="banner-alert-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.19" />
            </svg>
        </div>
        <div class="banner-text">
            <span class="banner-title">
                {{ langService.currentLang === 'mr' ? 'नवीन आकडेवारी उपलब्ध असू शकते' : 'New data may be available' }}
            </span>
            <span class="banner-desc">
                {{ langService.currentLang === 'mr'
                ? 'तुम्ही काही काळापासून डॅशबोर्डवर आहात. कृपया अद्ययावत माहितीसाठी वरील रिफ्रेश बटणावर क्लिक करा.'
                : 'You have been viewing the dashboard for a while. Please click the Refresh button above to load latest data.' }}
                <span *ngIf="lastUpdatedTime" class="banner-time">
                    ({{ langService.currentLang === 'mr' ? 'शेवटचे अद्यतन' : 'Last updated' }}: {{
                    getFormattedLastUpdated() }})
                </span>
            </span>
        </div>
    </div>
    <div class="banner-guide-hint" (click)="refreshDashboard()" [title]="langService.currentLang === 'mr' ? 'रिफ्रेश करा' : 'Click to refresh'">
        <span class="hint-text">
            {{ langService.currentLang === 'mr' ? 'वरील रिफ्रेश बटण दाबा' : 'Click Refresh button above' }}
        </span>
        <span class="hint-arrow">↗</span>
    </div>
</div> -->

<!-- RURAL / URBAN TOGGLE -->
<div class="rural-urban-toggle">
    <div class="toggle-option" [class.active]="selectedArea === 'rural'" (click)="onAreaChange('rural')">
        {{ langService.currentLang === 'mr' ? 'ग्रामीण' : 'Rural' }}
    </div>
    <div class="toggle-option" [class.active]="selectedArea === 'urban'" (click)="onAreaChange('urban')">
        {{ langService.currentLang === 'mr' ? 'शहरी' : 'Urban' }}
    </div>
</div>

<!--  GLOBAL NO DATA STATE -->
<div *ngIf="isUrbanNoData" class="global-empty-state">
    <div class="empty-card">
        <div class="empty-icon">📊</div>
        <div class="empty-subtitle">
            {{ langService.currentLang === 'mr' ? 'शहरी क्षेत्रासाठी माहिती उपलब्ध नाही' : 'No data available for Urban
            area' }}
        </div>
    </div>
</div>

<div *ngIf="!isUrbanNoData">

    <!-- TOP CARDS ROW — Family Registration summary (REAL data) -->
    <div class="dashboard-container">
        <div class="card asha-performance-card">
            <div class="asha-performance-title">
                {{ langService.currentLang === 'mr' ? 'कुटुंब नोंदणी' : 'Family Registration' }}
            </div>

            <div class="cards-row cards-row-5">
                <div class="card card-one" (click)="getFamiliesList()">
                    <img src="assets/dashboard icons/totalpopulation.png" class="card-icon" alt="" />
                    <div class="value" id="totalPopulationCoveredByAsha">{{ totalPopulationCoveredByAsha }}</div>
                    <div class="label">
                        {{ langService.currentLang === 'mr' ? 'आशा द्वारे समाविष्ट एकूण लोकसंख्या' : 'Total Population
                        Covered By Asha' }}
                    </div>
                </div>

                <!--   <div class="card card-two" (click)="getTotalAssignedFamiliesClick()">
                    <img src="assets/dashboard icons/assignedasha.png" class="card-icon" alt="" />
                    <div class="value" id="totalPopulationAssignedToAsha">{{ totalPopulationAssignedToAsha }}</div>
                    <div class="label">
                        {{ langService.currentLang === 'mr' ? 'आशाला नियुक्त एकूण लोकसंख्या' : 'Total Population
                        Assigned To Asha' }}
                    </div>
                </div> -->

                <div class="card card-three" (click)="getNooffamilies()">
                    <img src="assets/dashboard icons/nooffamilies.png" class="card-icon" alt="" />
                    <div class="value" id="noOfFamilies">{{ noOfFamilies }}</div>
                    <div class="label">{{ langService.currentLang === 'mr' ? 'कुटुंबांची संख्या' : 'No. of Families' }}
                    </div>
                </div>

                <div class="card card-four" (click)="get0to5yearchild()">
                    <img src="assets/dashboard icons/numberofchildrens.png" class="card-icon" alt="" />
                    <div class="value" id="childrenBelowFiveYears">{{ childrenBelowFiveYears }}</div>
                    <div class="label">
                        {{ langService.currentLang === 'mr' ? '0 ते 5 वर्षे वयोगटातील मुले' : 'Children (0–5 yrs)' }}
                    </div>
                </div>

                <div class="card card-five" (click)="getmemberabove30()">
                    <img src="assets/dashboard icons/30yearabove.png" class="card-icon" alt="" />
                    <div class="value" id="membersAboveThirtyYears">{{ membersAboveThirtyYears }}</div>
                    <div class="label">
                        {{ langService.currentLang === 'mr' ? '३० वर्षांवरील सदस्य' : 'Members Above 30 years' }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- REGISTRATIONS AND RECORDS -->
    <div class="dashboard-container">
        <h2 class="section-title">
            {{ langService.currentLang === 'mr' ? 'नोंदणी आणि नोंदी' : 'Registrations and Records' }}
        </h2>

        <div class="records-grid">

            <!-- 1. FAMILY REGISTRATION — pie chart  -->
            <div class="record-card">
                <div class="record-card-header-v2">
                    <span class="record-icon-badge pink">
                        <img src="assets/dashboard icons/familyregistration.png" alt="" />
                    </span>
                    <div class="record-title-group">
                        <span class="record-title">
                            {{ langService.currentLang === 'mr' ? 'कुटुंब नोंदणी' : 'Family Registration' }}
                        </span>
                    </div>
                    <span class="record-total">{{ familyStatusTotal }}</span>
                </div>

                <div class="family-row">
                    <dx-pie-chart [dataSource]="familyStatusData" [palette]="familyColors"
                        [size]="{ height: 160, width: 160 }" (onPointClick)="onFamilyPieClick($event)">
                        <dxo-animation [enabled]="true" [duration]="1000" easing="easeOutCubic"></dxo-animation>
                        <dxi-series argumentField="Name" valueField="Value" innerRadius="0.5">
                            <dxo-label [visible]="false"></dxo-label>
                        </dxi-series>
                        <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                        <dxo-legend [visible]="false"></dxo-legend>
                        <dxo-export [enabled]="false"></dxo-export>
                    </dx-pie-chart>

                    <div class="legend-list">
                        <div class="legend-item" *ngFor="let item of familyStatusData; let i = index"
                            (click)="onFamilyStatusClick(item)" style="cursor: pointer;">
                            <span class="legend-dot" [style.background]="familyColors[i]"></span>
                            <span class="legend-label">{{ langService.currentLang === 'mr' ? familyLabelMap[item.Name] :
                                item.Name }}</span>
                            <span class="legend-value">{{ item.Value }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 2. ANC — Antenatal Care -->
            <div class="record-card">
                <div class="record-card-header">
                    <span class="record-icon-badge pink">
                        <img src="assets/dashboard icons/anc.png" alt="" />
                    </span>
                    <span class="record-title">{{ langService.currentLang === 'mr' ? 'गर्भवती महिला (एएनसी)' : 'ANC —
                        Antenatal Care' }}</span>
                    <span class="record-total">{{ ancRegistered }}</span>
                </div>

                <div class="mini-stats-row">
                    <div class="mini-stat" (click)="onAncStatClick('registered')">
                        <div class="mini-stat-value">{{ ancRegistered }}</div>
                        <div class="mini-stat-label">{{ langService.currentLang === 'mr' ? 'नोंदणीकृत' : 'Registered' }}
                        </div>
                    </div>
                    <div class="mini-stat" (click)="onAncStatClick('pregnancydue')">
                        <div class="mini-stat-value">{{ ancPregnancyDue }}</div>
                        <div class="mini-stat-label">{{ langService.currentLang === 'mr' ? 'प्रसूती अपेक्षित' :
                            'Pregnancy Due' }}</div>
                    </div>
                </div>

                <div class="bar-row" (click)="onAncStatClick('highRisk')">
                    <span class="bar-row-label">{{ langService.currentLang === 'mr' ? 'उच्च जोखीम' : 'High Risk'
                        }}</span>
                    <div class="bar-track">
                        <div class="bar-fill red" [style.width.%]="ancHighRiskPercent"></div>
                    </div>
                    <span class="bar-row-value">{{ ancHighRisk }}</span>
                </div>
                <div class="bar-row" (click)="onAncStatClick('normal')">
                    <span class="bar-row-label">{{ langService.currentLang === 'mr' ? 'सामान्य माता' : 'Normal Maata'
                        }}</span>
                    <div class="bar-track">
                        <div class="bar-fill green" [style.width.%]="ancLowRiskPercent"></div>
                    </div>
                    <span class="bar-row-value">{{ ancLowRisk }}</span>
                </div>
            </div>

            <!-- 3. PNC — Postnatal Care -->
            <div class="record-card">
                <div class="record-card-header">
                    <span class="record-icon-badge pink">
                        <img src="assets/dashboard icons/pnc.png" alt="" />
                    </span>
                    <span class="record-title">{{ langService.currentLang === 'mr' ? 'प्रसूतीनंतरची काळजी (पीएनसी)' :
                        'PNC — Postnatal Care' }}</span>
                    <span class="record-total">{{ pncTotal }}</span>
                </div>

                <div class="mini-cards">
                    <div class="mini-card blue" (click)="onPncStatClick('NoofPNCRegistered')">
                        <div class="mini-card-value">{{ pncNoofPNCRegistered }}</div>
                        <div class="mini-card-label">{{ langService.currentLang === 'mr' ? '
                            नोंदणीकृत PNC ची संख्या' : 'No of PNC
                            Registered' }}
                        </div>
                    </div>
                    <div class="mini-card orange" (click)="onPncStatClick('visitsDue')">
                        <div class="mini-card-value">{{ pncVisitsDue }}</div>
                        <div class="mini-card-label">{{ langService.currentLang === 'mr' ? 'भेटी प्रलंबित' : 'Visits
                            due' }}
                        </div>
                    </div>
                    <div class="mini-card red" (click)="onPncStatClick('referredMaata')">
                        <div class="mini-card-value">{{ pncReferredMaata }}</div>
                        <div class="mini-card-label">{{ langService.currentLang === 'mr' ? 'संदर्भित माता' : 'Referred
                            Maata' }}</div>
                    </div>
                    <div class="mini-card green" (click)="onPncStatClick('completed')">
                        <div class="mini-card-value">{{ pncCompleted }}</div>
                        <div class="mini-card-label">{{ langService.currentLang === 'mr' ? 'पूर्ण' : 'Completed' }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 4. ELIGIBLE COUPLE REGISTER -->
            <div class="record-card">
                <div class="record-card-header-v2">
                    <span class="record-icon-badge pink">
                        <img src="assets/dashboard icons/Eligiblecouple.png" alt="" />
                    </span>
                    <div class="record-title-group">
                        <span class="record-title">
                            {{ langService.currentLang === 'mr' ? 'पात्र जोडपे नोंदणी' : 'Eligible Couple Register' }}
                        </span>
                    </div>
                    <span class="record-total">{{ ecrTotal }}</span>
                </div>

                <div class="mini-stats-row">
                    <div class="mini-stat" (click)="onEcrStatClick('eligible')">
                        <div class="mini-stat-value">{{ ecrEligibleCouples }}</div>
                        <div class="mini-stat-label">{{ langService.currentLang === 'mr' ? 'पात्र जोडपे' : 'Eligible
                            couples' }}</div>
                    </div>
                    <div class="mini-stat" (click)="onEcrStatClick('infertile')">
                        <div class="mini-stat-value">{{ ecrInfertileCouples }}</div>
                        <div class="mini-stat-label">{{ langService.currentLang === 'mr' ? 'अपत्यहीन जोडपे' : 'Infertile
                            couples' }}</div>
                    </div>
                </div>

                <div class="bar-row" (click)="onEcrStatClick('using')">
                    <span class="bar-row-label">{{ langService.currentLang === 'mr' ? 'कुटुंब नियोजन वापरत आहे' : 'Using
                        family planning' }}</span>
                    <div class="bar-track">
                        <div class="bar-fill green" [style.width.%]="ecrUsingPercent"></div>
                    </div>
                    <span class="bar-row-value">{{ ecrUsingFamilyPlanning }}</span>
                </div>
                <div class="bar-row" (click)="onEcrStatClick('notUsing')">
                    <span class="bar-row-label">{{ langService.currentLang === 'mr' ? 'वापरत नाही' : 'Not using'
                        }}</span>
                    <div class="bar-track">
                        <div class="bar-fill orange" [style.width.%]="ecrNotUsingPercent"></div>
                    </div>
                    <span class="bar-row-value">{{ ecrNotUsing }}</span>
                </div>
            </div>

            <!-- 5. BIRTH REGISTER -->
            <div class="record-card">
                <div class="record-card-header-v2">
                    <span class="record-icon-badge pink">
                        <img src="assets/dashboard icons/birthregister.png" alt="" />
                    </span>
                    <div class="record-title-group">
                        <span class="record-title">
                            {{ langService.currentLang === 'mr' ? 'जन्म नोंदणी' : 'Birth Register' }}
                        </span>
                    </div>
                    <div class="hbnc-total-group">
                        <span class="record-total">{{ birthTotal }}</span>
                        <span class="hbnc-total-sublabel" *ngIf="langService.currentLang === 'mr'">एकूण जन्म</span>
                    </div>
                </div>

                <div class="mini-cards birth-mini-cards">
                    <div class="mini-card-icon" (click)="onBirthStatClick('total')">
                        <span class="mini-card-icon-badge pink">
                            <img src="assets/dashboard icons/birthregisterA.png" alt="" />
                        </span>
                        <div class="mini-card-text">
                            <div class="mini-card-row">
                                <span class="mini-card-value" style="color:#e0468b">{{ birthTotal }}</span>
                                <span class="mini-card-label">{{ langService.currentLang === 'mr' ? '' : 'Total births'
                                    }}</span>
                            </div>
                            <div class="mini-card-sub" *ngIf="langService.currentLang === 'mr'">एकूण जन्म</div>
                        </div>
                    </div>

                    <div class="mini-card-icon" (click)="onBirthStatClick('still')">
                        <span class="mini-card-icon-badge green">
                            <img src="assets/dashboard icons/birthregisterB.png" alt="" />
                        </span>
                        <div class="mini-card-text">
                            <div class="mini-card-row">
                                <span class="mini-card-value" style="color:#3fae5c">{{ birthStillBirth }}</span>
                                <span class="mini-card-label">{{ langService.currentLang === 'mr' ? '' : 'Still Birth'
                                    }}</span>
                            </div>
                            <div class="mini-card-sub" *ngIf="langService.currentLang === 'mr'">मृतजन्म</div>
                        </div>
                    </div>

                    <div class="mini-card-icon" (click)="onBirthStatClick('male')">
                        <span class="mini-card-icon-badge red">
                            <img src="assets/dashboard icons/birthregisterC.png" alt="" />
                        </span>
                        <div class="mini-card-text">
                            <div class="mini-card-row">
                                <span class="mini-card-value" style="color:#333">{{ birthMale }}</span>
                                <span class="mini-card-label">{{ langService.currentLang === 'mr' ? '' : 'Boy' }}</span>
                            </div>
                            <div class="mini-card-sub" *ngIf="langService.currentLang === 'mr'">मुले</div>
                        </div>
                    </div>

                    <div class="mini-card-icon" (click)="onBirthStatClick('female')">
                        <span class="mini-card-icon-badge pink">
                            <img src="assets/dashboard icons/birthregisterD.png" alt="" />
                        </span>
                        <div class="mini-card-text">
                            <div class="mini-card-row">
                                <span class="mini-card-value" style="color:#333">{{ birthFemale }}</span>
                                <span class="mini-card-label">{{ langService.currentLang === 'mr' ? '' : 'Girl'
                                    }}</span>
                            </div>
                            <div class="mini-card-sub" *ngIf="langService.currentLang === 'mr'">मुली</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 6. DEATH REGISTER -->
            <div class="record-card death-card">
                <div class="record-card-header-v2">
                    <span class="record-icon-badge purple">
                        <img src="assets/dashboard icons/deathregister.png" alt="" />
                    </span>
                    <div class="record-title-group">
                        <span class="record-title">{{ langService.currentLang === 'mr' ? 'मृत्यू नोंदवही' : 'Death
                            Register' }}</span>
                    </div>
                    <div class="hbnc-total-group">
                        <span class="record-total">{{ deathTotal }}</span>
                        <span class="hbnc-total-sublabel" *ngIf="langService.currentLang === 'mr'">एकूण मृत्यू</span>
                    </div>
                </div>

                <div class="death-mini-grid">
                    <div class="death-mini-card" [style.background]="deathRowBg[0]" (click)="onDeathStatClick('total')">
                        <span class="death-mini-icon" [style.background]="deathIconBg[0]">
                            <img src="assets/dashboard icons/deathregisterA.png" alt="" />
                        </span>
                        <div class="death-mini-text">
                            <span class="death-mini-title">{{ langService.currentLang === 'mr' ? '' : 'Total Death'
                                }}</span>
                            <span class="death-mini-sub" *ngIf="langService.currentLang === 'mr'">एकूण मृत्यू</span>
                        </div>
                        <span class="death-mini-value" [style.background]="deathIconBg[0]"
                            [style.color]="deathColors[0]">{{ deathTotal }}</span>
                    </div>

                    <div class="death-mini-card" [style.background]="deathRowBg[1]" (click)="onDeathStatClick('0to5')">
                        <span class="death-mini-icon" [style.background]="deathIconBg[1]">
                            <img src="assets/dashboard icons/deathregisterB.png" alt="" />
                        </span>
                        <div class="death-mini-text">
                            <span class="death-mini-title">{{ langService.currentLang === 'mr' ? '' : '0–5 Years Death'
                                }}</span>
                            <span class="death-mini-sub" *ngIf="langService.currentLang === 'mr'">0-5 वर्षे
                                मृत्यू</span>
                        </div>
                        <span class="death-mini-value" [style.background]="deathIconBg[1]"
                            [style.color]="deathColors[1]">{{ death0To5Years }}</span>
                    </div>

                    <div class="death-mini-card" [style.background]="deathRowBg[2]" (click)="onDeathStatClick('anc')">
                        <span class="death-mini-icon" [style.background]="deathIconBg[2]">
                            <img src="assets/dashboard icons/deathregisterC.png" alt="" />
                        </span>
                        <div class="death-mini-text">
                            <span class="death-mini-title">{{ langService.currentLang === 'mr' ? '' : 'ANC Death'
                                }}</span>
                            <span class="death-mini-sub" *ngIf="langService.currentLang === 'mr'">प्रसूती दरम्यान
                                मृत्यू्</span>
                        </div>
                        <span class="death-mini-value" [style.background]="deathIconBg[2]"
                            [style.color]="deathColors[2]">{{ deathANC }}</span>
                    </div>

                    <div class="death-mini-card" [style.background]="deathRowBg[3]"
                        (click)="onDeathStatClick('30plus')">
                        <span class="death-mini-icon" [style.background]="deathIconBg[3]">
                            <img src="assets/dashboard icons/deathregisterD.png" alt="" />
                        </span>
                        <div class="death-mini-text">
                            <span class="death-mini-title">{{ langService.currentLang === 'mr' ? '' : '30+ Years Death'
                                }}</span>
                            <span class="death-mini-sub" *ngIf="langService.currentLang === 'mr'">30+ वर्षे
                                मृत्यू</span>
                        </div>
                        <span class="death-mini-value" [style.background]="deathIconBg[3]"
                            [style.color]="deathColors[3]">{{ death30PlusYears }}</span>
                    </div>
                </div>
            </div>

            <!-- 7. HBNC OVERVIEW — donut + numbered list -->
            <div class="record-card hbnc-card">
                <div class="record-card-header-v2">
                    <span class="record-icon-badge pink">
                        <img src="assets/dashboard icons/hbncoverview.png" alt="" />
                    </span>
                    <div class="record-title-group">
                        <span class="record-title">
                            {{ langService.currentLang === 'mr' ? 'एचबीएनसी आढावा' : 'HBNC Overview' }}
                        </span>
                    </div>
                    <div class="hbnc-total-group">
                        <span class="record-total">{{ hbncTotal }}</span>
                        <span class="hbnc-total-label">
                            {{ langService.currentLang === 'mr' ? 'एकूण जन्म' : 'Total Birth' }}
                        </span>
                    </div>
                </div>

                <div class="hbnc-body">
                    <div class="hbnc-chart-col">
                        <dx-pie-chart [dataSource]="hbncData" [palette]="hbncColors"
                            [size]="{ height: 140, width: 140 }" [centerTemplate]="'centerTemplate'">
                            <dxo-animation [enabled]="true" [duration]="1000" easing="easeOutCubic"></dxo-animation>
                            <dxi-series argumentField="Name" valueField="Value" type="doughnut" innerRadius="0.55">
                                <dxo-label [visible]="false"></dxo-label>
                            </dxi-series>
                            <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                            <dxo-legend [visible]="false"></dxo-legend>
                            <dxo-export [enabled]="false"></dxo-export>

                            <div *dxTemplate="let pieInfo of 'centerTemplate'">
                                <div class="donut-center">
                                    <div class="donut-center-title">
                                        {{ langService.currentLang === 'mr' ? 'एकूण जन्म' : 'Total Birth' }}
                                    </div>
                                    <div class="donut-center-value">{{ hbncTotal || 0 }}</div>
                                </div>
                            </div>
                        </dx-pie-chart>

                        <div class="hbnc-legend">
                            <div class="hbnc-legend-item" *ngFor="let item of hbncData; let i = index">
                                <span class="legend-dot" [style.background]="hbncColors[i]"></span>
                                <span>{{ langService.currentLang === 'mr' ? hbncLabelMap[item.Name].mr :
                                    hbncLabelMap[item.Name].en }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="hbnc-list-col">
                        <div class="hbnc-list-row" *ngFor="let item of hbncData; let i = index"
                            [style.background]="hbncRowBg[i]" (click)="onHbncItemClick(item)">
                            <span class="hbnc-list-icon" [style.background]="hbncIconBg[i]">
                                <img [src]="hbncIconImages[i]" alt="" />
                            </span>
                            <span class="hbnc-list-num" [style.color]="hbncColors[i]">{{ i + 1 }}</span>
                            <div class="hbnc-list-text">
                                <span class="hbnc-list-title">
                                    {{ langService.currentLang === 'mr' ? hbncLabelMap[item.Name].mr :
                                    hbncLabelMap[item.Name].en }}
                                </span>
                            </div>
                            <span class="hbnc-list-value" [style.color]="hbncColors[i]">{{ item.Value }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 8. IMMUNIZATION OVERVIEW — pie chart -->
            <div class="record-card immunization-card-v2">
                <div class="record-card-header-v2">
                    <span class="record-icon-badge pink">
                        <img src="assets/dashboard icons/fullyimmunized.png" alt="" />
                    </span>
                    <div class="record-title-group">
                        <span class="record-title">
                            {{ langService.currentLang === 'mr' ? 'लसीकरण आढावा' : 'Immunization Overview' }}
                        </span>
                    </div>
                    <div class="hbnc-total-group">
                        <span class="record-total">{{ immunizationTotal }}</span>
                        <span class="hbnc-total-label">
                            {{ langService.currentLang === 'mr' ? 'एकूण मुले' : 'Total Children' }}
                        </span>
                    </div>
                </div>

                <div class="immunization-row-v2">
                    <div class="immunization-chart-box">
                        <div class="immunization-chart-title">
                            {{ langService.currentLang === 'mr' ? 'लसीकरण स्थिती' : 'Immunization Status' }}
                        </div>

                        <dx-chart [dataSource]="immunizationData" [size]="{ height: 210, width: 220 }"
                            [customizePoint]="customizeImmunizationPoint"
                            (onPointClick)="onImmunizationBarClick($event)">
                            <dxo-common-series-settings argumentField="Name" type="bar">
                            </dxo-common-series-settings>
                            <dxi-series valueField="Value" argumentField="Name" name="Immunization">
                                <dxo-label [visible]="true" position="outside">
                                    <dxo-font [size]="11" [weight]="700"></dxo-font>
                                </dxo-label>
                            </dxi-series>
                            <dxo-legend [visible]="false"></dxo-legend>
                            <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                            <dxo-argument-axis [visible]="true">
                                <dxo-label [wordWrap]="'normal'" [alignment]="'center'"></dxo-label>
                            </dxo-argument-axis>
                            <dxo-value-axis title="Children" [visible]="true" [valueMarginsEnabled]="false" [min]="0"
                                [max]="immunizationAxisMax" [tickInterval]="immunizationTickInterval">
                            </dxo-value-axis>
                        </dx-chart>
                    </div>

                    <div class="immunization-list-col">
                        <div class="immunization-list-row" *ngFor="let item of immunizationData; let i = index"
                            [style.background]="immunizationRowBg[i]" (click)="onImmunizationItemClick(item)">
                            <span class="immunization-list-icon" [style.background]="immunizationIconBg[i]">
                                <img [src]="immunizationIconImages[i]" alt="" />
                            </span>
                            <span class="immunization-list-num" [style.color]="immunizationColors[i]">{{ i + 1 }}</span>
                            <div class="immunization-list-text">
                                <span class="immunization-list-title">
                                    {{ langService.currentLang === 'mr' ? immunizationLabelMap[item.Name] : item.Name }}
                                </span>
                            </div>
                            <span class="immunization-list-value" [style.color]="immunizationColors[i]">{{ item.Value
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 9. PREGNANCY LOSS -->
            <div class="record-card pregnancy-loss-card">
                <div class="record-card-header-v2">
                    <span class="record-icon-badge pink">
                        <img src="assets/dashboard icons/pregannacyloss.png" class="record-icon-img" alt="" />
                    </span>
                    <div class="record-title-group">
                        <span class="record-title">
                            {{ langService.currentLang === 'mr' ? 'गर्भहानी' : 'Pregnancy Loss' }}
                        </span>
                    </div>
                    <div class="hbnc-total-group">
                        <span class="record-total">{{ pregnancyLossTotal }}</span>
                        <span class="hbnc-total-label">
                            {{ langService.currentLang === 'mr' ? 'एकूण प्रकरणे' : 'Total Cases' }}
                        </span>
                    </div>
                </div>

                <div class="pregnancy-loss-grid">
                    <div class="pregnancy-loss-mini-card" (click)="onPregnancyLossStatClick('abortion')">
                        <span class="pregnancy-loss-icon">
                            <img src="assets/dashboard icons/abortion.png" alt="" />
                        </span>
                        <span class="pregnancy-loss-value">{{ pregnancyLossAbortion }}</span>
                        <div class="pregnancy-loss-text">
                            <span class="record-title">
                                {{ langService.currentLang === 'mr' ? 'गर्भपात' : 'Abortion' }}
                            </span>
                        </div>
                    </div>

                    <div class="pregnancy-loss-mini-card" (click)="onPregnancyLossStatClick('miscarriage')">
                        <span class="pregnancy-loss-icon">
                            <img src="assets/dashboard icons/Miscarriege.png" alt="" />
                        </span>
                        <span class="pregnancy-loss-value">{{ pregnancyLossMiscarriage }}</span>
                        <div class="pregnancy-loss-text">
                            <span class="record-title">
                                {{ langService.currentLang === 'mr' ? 'गर्भपात ((गर्भस्राव)' : 'Miscarriage' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>